import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Item, Blobs, BlobService, ItemsService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-item-upload-image',
  templateUrl: './item-upload-image.component.html',
  styleUrls: ['./item-upload-image.component.css']
})
export class ItemUploadImageComponent implements OnInit {
  itemDoc: AngularFirestoreDocument<Item>;
  blobDoc: AngularFirestoreDocument<Blobs>;
  indexDoc: AngularFirestoreDocument<string[]>;
  id: string;
  item: Item;
  blob: Blobs;
  bb: Observable<Blobs[]>;
  uploadPercent: Observable<number>;
  // store=firebase.storage();
  constructor(
    private blobservice: BlobService,
    private db: AngularFirestore,
    private storage: AngularFireStorage,
    private itemsservice: ItemsService,
    private route: ActivatedRoute, ) {

    }

    uploadFile(event) {
      // const n = this.item.id ;
      // const file = event.target.files[0];
      // const filePath = `blob/items/${this.item.id}`;
      // this.item.image_id = filePath;
      // this.itemsservice.update(this.item);
      // const task = this.storage.upload(filePath, file);

      // const ref = this.storage.ref(filePath);
      // // observe percentage changes
      // this.uploadPercent = task.percentageChanges();
      // task.then(m => {
      //   const meta = ref.getMetadata();
      //   const url = ref.getDownloadURL();
      //   url.subscribe(d => {
      //     meta.subscribe( me => {
      //       const x:Date=me.timeCreated;
      //       const b: Blobs = {
      //         id:this.item.id,
      //         downloadURL: d,
      //         contentType: me.contentType,
      //         name: me.fullPath,
      //         title: this.item.descrizione,
      //         path: me.name,
      //         timeCreated:new Date(me.timeCreated),
      //         updated:new Date(me.updated),
      //       createat:new Date()
      //       };

      //       this.blobservice.update(b);

      //     });
      //   });
      // });
    }

  ngOnInit() {
this.id = this.route.snapshot.params.id;
// const ref=this.store.ref(`blob/items/${this.id}`);
// getDownloadURL(ref).subscribe(c=>console.log(c));
// getMetadata(ref).subscribe(c=>console.log(c));

this.itemDoc = this.db.collection<Item>('item').doc<Item>(this.id);
this.blobDoc = this.itemDoc.collection('blobs').doc<Blobs>(this.id);
this.indexDoc = this.blobDoc.collection('indexDoc').doc(this.id);
this.itemsservice.details(this.id).subscribe(i => {
      this.item = i;
    }
      );
this.bb = this.db.collection<Blobs>('blobs')
.valueChanges({idFields: 'id'});
  }

}
